import { createAsyncThunk } from '@reduxjs/toolkit';
import i18n from 'i18n';
import {
  applyPromocode,
  checkPromocodeAvailability,
} from 'store/api/cuverse-api/promocode/promocode.service';
import {
  PromocodeApplyResponseSchema,
  PromocodeCheckResponseSchema,
  TPromocodeApplyData,
  TPromocodeCheckData,
} from 'store/api/cuverse-api/promocode/types/promocode-response.interface';
import { updateInvoiceStateAction } from 'store/invoice-reducer/invoice.reducer';

import { requestWithZodSchema } from 'utils/common/requestWithZodSchema';
import { notifyError } from 'utils/notify/notify.utils';

import { EPromoCodeCategories } from './constants/promocode-categories';

interface ICheckPromo {
  category: EPromoCodeCategories;
  promoCode: string;
}

export const checkPromoAvailabilityThunkAction = createAsyncThunk<TPromocodeCheckData, ICheckPromo>(
  'promocode/checkPromoAvailability',
  async ({ category, promoCode }) => {
    return await requestWithZodSchema(
      () =>
        checkPromocodeAvailability({
          coupon_type: category,
          coupon_code: promoCode,
        }),
      PromocodeCheckResponseSchema,
    ).catch((error) => {
      if (error.response?.data.errors?.coupon_code) {
        notifyError(i18n.t('notifyMessages.promocode.invalidSelectedCouponCodeError'));
        throw error;
      }

      notifyError(i18n.t('notifyMessages.promocode.checkPromoAvailabilityError'));
      throw error;
    });
  },
);

interface IApplyPromo {
  category: EPromoCodeCategories;
  purchaseId?: number;
  promoCode: string;
}

export const applyPromoThunkAction = createAsyncThunk<TPromocodeApplyData, IApplyPromo>(
  'promocode/applyPromo',
  async ({ category, purchaseId = null, promoCode }, { dispatch }) => {
    return await requestWithZodSchema(
      () =>
        applyPromocode({
          coupon_type: category,
          purchase_id: purchaseId,
          coupon_code: promoCode,
        }),
      PromocodeApplyResponseSchema,
    )
      .then((res) => {
        dispatch(updateInvoiceStateAction(res));

        return res;
      })
      .catch((error) => {
        if (error.response?.data.errors?.coupon_code) {
          notifyError(i18n.t('notifyMessages.promocode.invalidSelectedCouponCodeError'));
          throw error;
        }

        notifyError(i18n.t('notifyMessages.promocode.checkPromoAvailabilityError'));
        throw error;
      });
  },
);
